export default __webpack_public_path__ + "static/media/icon_paperclip.8d760117.svg";